export default __webpack_public_path__ + "static/media/mathematics.c241ae21.PNG";